
/**
 * ISO 3166-1 alpha-2 codes for all the supported countries.
 * For more information see: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
 */
export enum Country {
    Austria = 'AT',
    Hungary = 'HU',
    Romania = 'RO',
    Slovakia = 'SK',
    Slovenia = 'SI',
}
